import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

type ProfileSettings = {
  queueFocusCount: number;
  queueMaintenanceCount: number;
  defaultSnoozeDays: number;
};

export type ProfileResponse = {
  userId: string;
  email: string;
  name: string;
  roles: string[];
  settings: ProfileSettings | null;
};

type UpdateProfileRequest = {
  name?: string;
  settings?: {
    queueFocusCount?: number;
    queueMaintenanceCount?: number;
    defaultSnoozeDays?: number;
  };
};

export function useProfile(): ReturnType<typeof useQuery<ProfileResponse>> {
  return useQuery({
    queryKey: ['profile'],
    queryFn: () => api.fetch<ProfileResponse>('/profile'),
  });
}

export function useUpdateProfile(): ReturnType<typeof useMutation<ProfileResponse, Error, UpdateProfileRequest>> {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (data: UpdateProfileRequest) =>
      api.fetch<ProfileResponse>('/profile', {
        method: 'PATCH',
        body: JSON.stringify(data),
      }),
    onSuccess: () => {
      void queryClient.invalidateQueries({ queryKey: ['profile'] });
    },
  });
}
